export const showPassword = () => {
  const passwordBlockNode = document.querySelector(`.js-password`);

  if (passwordBlockNode) {
    const showButton = passwordBlockNode.querySelector(`.js-show-btn`);
    const passwordFields = passwordBlockNode.querySelector(`.js-password-fields`);
    const inputWrappers = passwordBlockNode.querySelectorAll(`.js-input-wrap`);

    function showPasswordFields() {
      passwordFields.classList.toggle(`profile__fields--show`);
      showButton.textContent = showButton.textContent === "Отмена".trim() ? "Изменить пароль" : "Отмена";
    }

    function toggleInputType(input, eyeButton) {
      if (input.type === `password`) {
        input.type = `text`;
        eyeButton.classList.add(`profile__eye--show`);
      } else {
        input.type = `password`;
        eyeButton.classList.remove(`profile__eye--show`);
      }
    }

    if (inputWrappers.length) {
      inputWrappers.forEach((wrapper) => {
        const eyeButton = wrapper.querySelector(`.js-eye-btn`);
        const input = wrapper.querySelector(`input`);

        const onEyeButtonClick = () => {
          toggleInputType(input, eyeButton);
        };

        eyeButton.addEventListener(`click`, onEyeButtonClick);
      });
    }

    if (showButton) {
      showButton.addEventListener(`click`, showPasswordFields);
    }
  }
};
